import { css, html, LitElement } from "lit"

export default class PageRessourcesUtile extends LitElement {
  static properties = {}

  static styles = css`

    .conteneur-ressources {
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
    }

    ul {
        list-style-type: none;
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .drapeau {
        width: 24px;
        margin-right: 10px;
    }

    a {
        display: flex;
        align-items: center;
        background-color: var(--couleur-200); /* Gris foncé */
        color: var(--couleur-texte); /* Texte blanc pour plus de lisibilité */
        padding: 16px;
        margin: 8px 0;
        border-radius: 12px;
        text-decoration: none;
        border-left: 4px solid var(--couleur-600); /* Petite barre bleue sur le côté */
        transition: background 0.2s;
        width: 100%;
        }

        a:active {
        background-color: #333; /* Effet de pression au clic */
        }
    `

  render() {
    return html`
                        <h1>Ressources utiles</h1>
            <p>Voici une liste de ressources utiles pour les joueurs de Pokémon Go qui souhaitent en savoir plus l'actualité du jeu notamment les événements et récompenses à la clé :</p>

            <div class="conteneur-ressources">

                <div>
                    <h2><img src="../../images/drapeau_francais.png" class="drapeau" alt="drapeau français" /> Ressources en français <img src="../../images/drapeau_francais.png" class="drapeau" alt="drapeau français" /></h2>
                    <ul>
                        <li><a href="https://www.pokemongolive.com/fr/news/" target="_blank">Site officiel de Pokémon Go - Actualités</a></li>
                        <li><a href="https://www.pokekalos.com/pokemon-go/events" target="_blank">Pokekalos - Événements Pokémon Go</a></li>
                    </ul>
                </div>
    
                <div>
                    <h2><img src="../../images/drapeau_anglais.png" class="drapeau" alt="drapeau anglais" /> Ressources en anglais <img src="../../images/drapeau_anglais.png" class="drapeau" alt="drapeau anglais" /></h2>
                    <ul>
                        <li><a href="https://leekduck.com/events/" target="_blank">Leek Duck - Événements</a></li>
                        <li><a href="https://leekduck.com/research/" target="_blank">Leek Duck - Recherche de terrain</a></li>
                        <li><a href="https://leekduck.com/raid-bosses/" target="_blank">Leek Duck - Boss de raids</a></li>
                        <li><a href="https://leekduck.com/rocket-lineups/" target="_blank">Leek Duck - Les combats rockets</a></li>
                    </ul>
                </div>
            </div>
                `
  }
}
customElements.define("p-page-ressources-utile", PageRessourcesUtile)
